module.exports = __webpack_public_path__ + "static/media/20.thunderbird.edae7ebb.svg";